import { useTranslation } from 'react-i18next';
import {
  EMPTY_ILLUSTRATIONS,
  EmptyContainer,
  Table,
  Typography,
} from '@thinknet-gmbh/platform-common-ui';

import { dateTimeFormat } from 'src/common/helpers/date.helpers';

import DocumentImportPatternsTableRowActions from './document-importer-table-row-actions.component';
import { IDocumentImporterTableProps } from '../../document-importer-list.interfaces';

const DocumentImporterTable = ({
  dataSource,
  paginationConfig,
  handleModals,
  loading,
}: IDocumentImporterTableProps) => {
  const { t } = useTranslation(['common', 'documentImporter']);

  return (
    <Table
      loading={loading}
      dataSource={dataSource}
      pagination={paginationConfig}
      rowKey={record => record._id}
      locale={{
        emptyText: (
          <EmptyContainer
            illustration={EMPTY_ILLUSTRATIONS.dataAnalysis}
            emptyTitle={t('common:emptyContainer.emptyTitle')}
          />
        ),
      }}
      t={t}
    >
      <Table.Column
        title={t('documentImporter:labels.title')}
        render={({ title }) => <Typography>{title}</Typography>}
      />

      <Table.Column
        title={t('documentImporter:labels.importedAt')}
        render={({ createdAt }) => <Typography>{dateTimeFormat(createdAt)}</Typography>}
      />

      <Table.Column
        title={t('documentImporter:labels.totalImportedDocuments')}
        render={({ totalImportedDocuments }) => <Typography>{totalImportedDocuments}</Typography>}
      />

      <Table.Column
        width={50}
        title={t('common:labels.action')}
        render={record => (
          <DocumentImportPatternsTableRowActions
            record={record}
            handleModals={handleModals}
            t={t}
          />
        )}
      />
    </Table>
  );
};

export default DocumentImporterTable;
